import React from 'react';

import { Box } from '../Box';
import { Link } from '../Link';
import { Label, Text } from '../Typography';
import { VStack } from '../VStack';
import { EmptyStateProps } from './interface';

export const EmptyState = <RouteMap,>({
  title,
  description,
  linkProps,
  linkText,
}: EmptyStateProps<RouteMap>) => {
  return (
    <VStack py={3} alignItems="center">
      <Box pb={0.5}>
        <Label size="m">{title}</Label>
      </Box>
      <Box width="360px">
        <Text size="s" color="text.secondary" textAlign="center">
          {description}
        </Text>
      </Box>
      {!!linkProps && (
        <Box pt={2}>
          <Text size="s" color="text.secondary">
            {/* @ts-ignore-next-line Typescript is not resolving linkProps correctly */}
            <Link<RouteMap> {...linkProps} variant="text" size="s">
              {linkText}
            </Link>
          </Text>
        </Box>
      )}
    </VStack>
  );
};
